var pug = require("!../../../node_modules/pug/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (hideClose, message, navigate, theme) {
      pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["toaster",theme], [false,true]), false, true)+pug.attr("data-navigate", navigate, true, true)) + "\u003E\u003Cdiv class=\"toaster-message\"\u003E" + (null == (pug_interp = message) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
if (!hideClose) {
pug_html = pug_html + "\u003Cdiv class=\"toaster-close\" data-click=\"close-toast,stop-propagation\"\u003E\u003Ci class=\"mdi-navigation-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "hideClose" in locals_for_with ?
        locals_for_with.hideClose :
        typeof hideClose !== 'undefined' ? hideClose : undefined, "message" in locals_for_with ?
        locals_for_with.message :
        typeof message !== 'undefined' ? message : undefined, "navigate" in locals_for_with ?
        locals_for_with.navigate :
        typeof navigate !== 'undefined' ? navigate : undefined, "theme" in locals_for_with ?
        locals_for_with.theme :
        typeof theme !== 'undefined' ? theme : undefined));
    ;;return pug_html;};
module.exports = template;